<admin-page-second [title]="'pages.decisions.models' | translate">
  <admin-section-standard *ngFor="let channel of definitions()" [title]="channel!.config!.description!">
    <div class="row">
      <div class="col-md-12">
        <admin-decisions-model [channel]="channel"></admin-decisions-model>
      </div>
    </div>
  </admin-section-standard>
</admin-page-second>
